import React, { useEffect } from 'react'
import { Link, useLocation } from 'react-router-dom'
import Header from './components/Header'
import Footer from './components/Footer'
import FestivalHero from './sections/FestivalHero'
import ProgramSection from './sections/ProgramSection'
import { getFestivals } from '../data/loadData'

export default function Festival() {
  const location = useLocation()
  const year = parseInt(new URLSearchParams(location.search).get('f'), 10)
  const exists = getFestivals().some((festival) => festival.id === year)

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [year])

  return (
    <React.Fragment>
      <Header />
      {exists ? (
        <>
          <FestivalHero year={year} />
          <ProgramSection key={year} year={year} />
        </>
      ) : (
        <section className='hero-area hero-ethos' lang='tr'>
          <div className='container hero-ethos-row hero-ethos-row--single'>
            <div className='hero-ethos-text'>
              <h1 className='hero-ethos-title'>
                <span className='hero-ethos-name'>FESTİVAL BULUNAMADI</span>
              </h1>
              <p className='hero-ethos-theme'>Aradığınız yıla ait bir festival kaydı yok.</p>
              <div className='hero-ethos-actions'>
                <Link className='hero-ethos-cta' to='/'>Ana sayfaya dön</Link>
              </div>
            </div>
          </div>
        </section>
      )}
      <Footer />
    </React.Fragment>
  )
}
